import { OrderStatus } from './../../enums/status.enum';
import { AuthService } from './../../services/auth.service';
import { IUrlSystem } from './../../interfaces/urls.model';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import { Subscription } from 'rxjs';
import { OnInit, Injector, OnDestroy } from '@angular/core';
import { BaseService } from '../../services/base.service';
import { BaseModel } from '../../models/base.model';
import { Status } from '../../enums/status.enum';

export abstract class BaseListComponent<T extends BaseModel> implements OnInit, OnDestroy {

    //dependency injection
    protected toastr: ToastrManager;
    protected activetedRoute: ActivatedRoute;
    protected auth: AuthService;

    // proprieties
    public objects: Array<T>;
    public listSubscription: Subscription;
    public isSpinnerLoading: boolean;
    public redirect: Router;

    constructor(
        protected baseService: BaseService<T>,
        protected injector: Injector,
        protected objTypeName: string,
        protected urls: IUrlSystem,
    ) {
        this.initParentProprieties()
        this.initChildProprieties()
    }

    private initParentProprieties() {
        this.isSpinnerLoading = false;
        this.objects = new Array<T>();
        this.listSubscription = new Subscription();
        this.toastr = this.injector.get(ToastrManager);
        this.auth = this.injector.get(AuthService);
        this.redirect = this.injector.get(Router);
        this.activetedRoute = this.injector.get(ActivatedRoute);
    }

    ngOnDestroy(): void {
        if (!this.listSubscription) return

        this.listSubscription.unsubscribe()
    }

    ngOnInit() {
        this.fetchAll()
        this.initChildMethods()
    }

    fetchAll(): void {
        this.isSpinnerLoading = true
        this.listSubscription.add(this.baseService.getAll().subscribe((objects) => {
            this.objects = objects.sort((a, b) => b.id - a.id)
            this.isSpinnerLoading = false
        }, () => this.isSpinnerLoading = false))
    }


    create(): void {
        this.redirect.navigate([this.urls.createUrl])
    }

    edit(obj: T): void {
        this.redirect.navigate([this.urls.editUrl])
            .then(() => this.baseService.setObject(obj, this.objTypeName))
    }

    detail(obj: T): void {
        this.redirect.navigate([this.urls.detailUrl])
            .then(() => this.baseService.setObject(obj, this.objTypeName))
    }


    delete(obj: T): void {
        if (confirm('Deseja realmente, remover este registo?')) {
            this.listSubscription.add(this.baseService.delete(obj.id).subscribe((message: string) => {
                this.objects = this.objects.filter(element => element != obj)
                this.toastr.successToastr(message)
            }))
        }
    }

    changeStatus(obj: T) {

        if (confirm('Deseja realmente mudar o estado deste registo?')) {
            this.baseService.updateStatus(obj)
                .subscribe(data => {

                    // actualizando o status do perfil
                    const index= this.objects.findIndex(object => object.id===obj.id);
                    this.objects[index].status=data.data.status;
                    this.objects[index].received_date=data.data.received_date;
                    this.objects[index].in_process_date=data.data.in_process_date;
                    this.objects[index].sent_date=data.data.sent_date;

                    this.toastr.successToastr(data.message, 'Mensagem', { position: 'top-center' })
                })
        }

    }

    //function to inicializate child methods
    protected abstract  initChildMethods(): void

    // function to inicializate child proprieties
    protected abstract initChildProprieties(): void

    // function to inicializate table columns
    protected abstract tableProprieties(): string[]

     // permissões
     isAdmin():boolean{
        return this.auth.user.roles[0].name==='admin';
    }

    isManager():boolean{
        return this.auth.user.roles[0].name==='manager';
    }

    isUserClub():boolean{
        return this.auth.user.roles[0].name==='userClube';
    }

    isUserKhuzela():boolean{
        return this.auth.user.roles[0].name==='user';
    }

    isAdminOrUserKhuzela():boolean{
        return this.isAdmin() || this.isUserKhuzela();
    }

    isManagerOrUserClub():boolean{
        return this.isManager() || this.isUserClub();
    }

    isAdminOrManager():boolean{
        return this.isManager() || this.isAdmin();
    }

    isAll():boolean{
      return this.isAdmin() || this.isUserKhuzela() || this.isManager() || this.isUserClub();
    }

}
